<template>
  <el-form
    :inline="true"
    :model="form"
    :rules="formRules"
    ref="form"
    label-position="top"
    label-width="100%"
    v-loading="loading"
  >
    <div class="border rounded-lg flex flex-col w-full h-full bg-white">
      <div
        class="h-12 bg-report-bell text-white w-full rounded-t-lg flex items-center px-4"
      >
        <h5 class="text-base font-bold">Details</h5>
      </div>
      <div id="content-data" class="h-auto overflow-auto">
        <div class="px-4 flex flex-col lg:flex-row mt-4 w-full">
          <div class="lg:flex-1 flex flex-col space-y-4">
            <div class="w-full flex">
              <div class="w-1/2">
                <strong class="text-base font-bold">Formula Name</strong>
              </div>
              <div class="w-1/2 flex flex-col">
                <el-form-item class="w-full mb-0" prop="VarName">
                  <el-input
                    placeholder="Please input Formula Name"
                    v-model="form.VarName"
                    clearable
                    :disabled="disableEditing()"
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="w-full flex">
              <div class="w-1/2">
                <strong class="text-base font-bold">Formula Label</strong>
              </div>
              <div class="w-1/2 flex flex-col">
                <el-form-item class="w-full mb-0" prop="VarLabel">
                  <el-input
                    placeholder="Please input Formula Label"
                    v-model="form.VarLabel"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="w-full flex">
              <div class="w-1/2">
                <strong class="text-base font-bold">Operator</strong>
              </div>
              <div class="w-1/2">
                <el-form-item class="w-full mb-0" prop="ProcessForm">
                  <el-select
                    v-model="form.ProcessForm"
                    clearable
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in operators"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="w-full flex">
              <div class="w-1/2">
                <strong class="text-base font-bold">Tag</strong>
              </div>
              <div class="w-1/2">
                <el-form-item class="w-full mb-0" prop="Tags">
                  <el-select
                    v-model="form.Tags"
                    placeholder="Select"
                    clearable
                    multiple
                  >
                    <el-option
                      v-for="item in tags"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="w-full flex">
              <div class="w-1/2">
                <strong class="text-base font-bold">Unit</strong>
              </div>
              <div class="w-1/2">
                <el-form-item class="w-full mb-0" prop="Unit">
                  <el-input
                    placeholder="Formula Unit (optional)"
                    v-model="form.Unit"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="lg:flex-1 pl-2 mt-4 lg:mt-0">
            <div class="border rounded-lg p-4 flex flex-col space-y-4">
              <div class="w-full flex flex-col space-y-2">
                <div class="w-full">
                  <strong class="text-base font-bold">Group Device Name</strong>
                </div>
                <div class="w-full">
                  <el-form-item class="w-full mb-0" prop="Unit">
                    <el-input
                      placeholder="Group Device Name (optional)"
                      v-model="form.GroupDeviceName"
                      clearable
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="flex flex-col space-y-2">
                <strong class="text-base font-bold">Select Device Group</strong>
                <div>
                  <el-input
                    placeholder="Search Device Groups"
                    v-model="filterdeviceGroups"
                  >
                  </el-input>

                  <el-tree
                    class="h-32 overflow-auto border border-t-0 rounded-b-lg p-2"
                    :data="deviceGroups"
                    :props="defaultProps"
                    :filter-node-method="filterNode"
                    ref="deviceGroupsTree"
                    node-key="Dce_id"
                    default-expand-all
                    show-checkbox
                    :check-strictly="true"
                    highlight-current
                    empty-text="No Data"
                    :check-on-click-node="true"
                    @check="onDeviceGroupSelected"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="w-full px-4 mt-4 flex flex-col"
          v-if="form.ProcessForm === 'formula'"
        >
          <div class="flex justify-end py-4">
            <el-button type="primary" @click="addFormula()">
              Add <i class="el-icon-plus" />
            </el-button>
          </div>

          <SimpleTable
            :headers="getHeaders()"
            :items="formulaTable"
            :customizationPage="customizationPage"
            :options="options"
            @edit-row="editForm"
            @remove-row="deleteRow"
          />

          <FormulaForm
            :type-form="typeForm"
            :formula-data="formulaData"
            :add-form-dialog="addFormDialog"
            :operators="operators.filter((x) => x.value !== 'formula')"
            :formula-sensor="sensorData"
            :formula-sensor-groupped="grouppedSensorData"
            :formula-custom="formulaTable"
            :formula-constanta="formulaConstanta"
            :formula-operation="formulaOperation"
            @save-form="saveForm()"
            @cancel-form="cancelForm()"
            @update-form="updateForm()"
            @fetch-constanta="fetchFormulaConstanta"
          />
        </div>
        <div class="flex justify-between px-4 py-4">
          <div>
            <el-button
              icon="el-icon-d-arrow-left"
              :disabled="disableButton"
              v-if="!$route.query.Id"
              @click="$router.go(-1)"
            >
              Back
            </el-button>
            &nbsp;
          </div>
          <div>
            <el-button
              type="danger"
              :disabled="disableButton"
              v-if="$route.query.Id"
              @click="close()"
            >
              Close
            </el-button>

            <el-button type="primary" :disabled="disableButton" @click="done()"
              >Submit</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import FormulaForm from '@/components/formula/FormulaForm'
import SimpleTable from '@/components/dx/SimpleTable'

export default {
  components: {
    FormulaForm,
    SimpleTable
  },
  props: {
    sensorData: {
      type: Array,
      required: true
    },
    grouppedSensorData: {
      type: Object,
      required: true
    },
    checkedSensors: {
      type: Array,
      required: true
    }
  },
  data() {
    var validateVarName = async (rule, value, callback) => {
      if (value == '') {
        callback(new Error('Formula Name is required'))
      } else if (!(await this.validateName(value))) {
        callback(new Error('Formula Name Already used'))
      } else {
        callback()
      }
    }
    return {
      selectedRow: '',
      groupDeviceId: '',
      typeForm: '',
      filterdeviceGroups: '',
      deviceGroups: [],
      formulaTable: [],
      formulaConstanta: [],
      form: {
        Id: 1,
        NoUrut: 1,
        VarName: '',
        VarType: 'sensor',
        VarLabel: '',
        ProcessForm: '',
        ListSensorDceId: [],
        CustomerName: '',
        Tags: [],
        DceGroupDeviceId: '',
        GroupDeviceName: '',
        Unit: ''
      },
      formulaData: {
        id: 1,
        NoUrut: 1,
        Source_1: '',
        Source_1_Name: '',
        Source_1_constant: '',
        ProcessForm_1: '',
        VarType_1: '',
        OperationFormula: '',
        Source_2: '',
        Source_2_Name: '',
        Source_2_constant: '',
        ProcessForm_2: '',
        VarType_2: '',
        VarName: '',
        VarType: 'process',
        CustomerName: '',
        Tags: [],
        DceGroupDeviceId: '',
        GroupDeviceName: '',
        Unit: ''
      },
      formulaOperation: [
        {
          value: 'plus',
          label: 'Plus  (+)'
        },
        {
          value: 'divided',
          label: 'Divided (/)'
        },
        {
          value: 'minus',
          label: 'Minus (-)'
        },
        {
          value: 'times',
          label: 'Times (x)'
        }
      ],
      addFormDialog: false,
      operators: [
        {
          value: 'average',
          label: 'Average'
        },
        {
          value: 'sum',
          label: 'Sum'
        },
        {
          value: 'min',
          label: 'Minimum'
        },
        {
          value: 'max',
          label: 'Maximum'
        },
        {
          value: 'formula',
          label: 'Formula'
        }
      ],
      tags: [],
      customer: [],
      deviceData: [],
      content: true,
      loading: false,
      formRules: {
        VarName: [
          {
            // message: 'Formula Name is required',
            trigger: 'change',
            validator: validateVarName
          }
        ],
        VarLabel: [
          {
            required: true,
            message: 'Formula Label is required',
            trigger: 'change'
          }
        ],
        ProcessForm: [
          {
            required: true,
            message: 'Operator is required',
            trigger: 'change'
          }
        ],
        Tags: [
          {
            required: true,
            message: 'Tags is required',
            trigger: 'change'
          }
        ]
      },
      customizationPage: '',
      options: {
        allowToRefetch: false,
        allowToNextStep: false,
        allowSorting: false,
        autoWidth: true
      },
      defaultProps: {
        children: 'children',
        label: 'Name'
      },
      disableButton: false,
      formulaLength: 1
    }
  },
  mounted() {
    this.fetchDataById()
    this.fetchDeviceGroup()
    this.fetchFormulaConstanta()
    this.fetchTags()
    this.getCustomer()
  },
  methods: {
    getHeaders() {
      var headers = [
        {
          type: 'number',
          text: '#',
          value: 'NoUrut'
        },
        {
          type: 'string',
          text: 'Variable Name',
          value: 'VarName'
        },
        {
          type: 'string',
          text: 'Variable 1',
          value: 'Source_1_Name'
        },
        {
          type: 'string',
          text: 'Function 1',
          value: 'ProcessForm_1'
        },
        {
          type: 'string',
          text: 'Operators',
          value: 'OperationFormula'
        },
        {
          type: 'string',
          text: 'Variable 2',
          value: 'Source_2_Name'
        },
        {
          type: 'string',
          text: 'Function 2',
          value: 'ProcessForm_2'
        }
      ]

      // if (!this.disableEditing()) {
      headers.push({
        type: 'string',
        text: 'Action',
        value: 'Id',
        allowFixing: true,
        cellTemplate: 'commonAction'
      })
      // }

      return headers
    },
    addFormula() {
      this.resetForm()

      // if (this.formulaLength)
      this.formulaData.VarName = this.form.VarName + ' - ' + this.formulaLength

      this.addFormDialog = true
      this.typeForm = 'Add'
    },
    deleteRow(val) {
      this.formulaTable.splice(val.rowIndex, 1)

      // update formulaLength
      this.setFormulaLenght()
      // update NoUrut
      this.reloadNoUrut()
    },
    editForm(val) {
      this.addFormDialog = true
      this.typeForm = 'Edit'
      this.selectedRow = val.rowIndex
      const clone = JSON.parse(
        JSON.stringify(this.formulaTable[this.selectedRow])
      )
      this.formulaData = clone
    },
    updateForm() {
      const clone = JSON.parse(JSON.stringify(this.formulaData))
      const formModel = {
        Id: clone.Id,
        NoUrut: clone.NoUrut,
        Source_1: clone.Source_1,
        Source_1_Name: clone.Source_1_Name,
        Source_1_constant: clone.Source_1_constant,
        ProcessForm_1: clone.ProcessForm_1,
        VarType_1: clone.VarType_1,
        OperationFormula: clone.OperationFormula,
        Source_2: clone.Source_2,
        Source_2_Name: clone.Source_2_Name,
        Source_2_constant: clone.Source_2_constant,
        ProcessForm_2: clone.ProcessForm_2,
        VarType_2: clone.VarType_2,
        VarName: clone.VarName,
        VarType: 'process',
        Tags: this.form.Tags,
        CustomerName: this.form.CustomerName,
        DceGroupDeviceId: this.form.DceGroupDeviceId,
        GroupDeviceName: this.form.GroupDeviceName,
        Unit: this.form.Unit
      }
      // Object.assign(this.selectedRow, this.formulaTable)

      this.$set(this.formulaTable, this.selectedRow, formModel)

      // update formulaLength
      this.setFormulaLenght()
      // set main form var label
      this.setVarLabelForAllFormula()
      this.resetForm()
      this.addFormDialog = false
    },
    cancelForm() {
      this.addFormDialog = false
    },
    saveForm() {
      this.formulaData.Tags = this.form.Tags
      this.formulaData.DceGroupDeviceId = this.groupDeviceId
      this.formulaData.Unit = this.form.Unit
      this.formulaData.GroupDeviceName = commonData.GroupName
      this.formulaTable.push(this.formulaData)
      this.resetForm()
      this.addFormDialog = false

      // update formulaLength
      this.setFormulaLenght()
      // set main form var label
      this.setVarLabelForAllFormula()

      // update NoUrut
      this.reloadNoUrut()
    },
    reloadNoUrut() {
      var noUrut = 1
      for (var formula of this.formulaTable) {
        var currentNoUrut = noUrut++
        formula.Id = currentNoUrut
        formula.NoUrut = currentNoUrut
      }
    },
    resetForm() {
      this.formulaData = {
        Id: 1,
        NoUrut: 1,
        Source_1: '',
        Source_1_Name: '',
        Source_1_constant: '',
        ProcessForm_1: '',
        VarType_1: '',
        OperationFormula: '',
        Source_2: '',
        Source_2_Name: '',
        Source_2_constant: '',
        ProcessForm_2: '',
        VarType_2: '',
        VarName: '',
        VarType: 'process',
        Tags: [],
        CustomerName: this.form.CustomerName
      }
    },
    onDeviceGroupSelected(value, data) {
      var checkedNodes = null
      if (data.checkedKeys.length) {
        checkedNodes = data.checkedKeys[0]
      }

      this.deviceGroups = this.setDeviceGroupDisability(
        this.deviceGroups,
        checkedNodes
      )
      this.$refs.deviceGroupsTree.setCheckedKeys(data.checkedKeys)
      this.groupDeviceId = checkedNodes
      this.form.DceGroupDeviceId = checkedNodes
    },
    setDeviceGroupDisability(data, selectedId = null) {
      var _this = this

      // set disability
      return data.map(function (item) {
        if (selectedId) {
          item.disabled = item.Dce_id !== selectedId
        } else {
          item.disabled = false
        }

        // find on children data
        if (item.children.length) {
          _this.setDeviceGroupDisability(item.children, selectedId)
        }
        return item
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.Name.indexOf(value) !== -1
    },
    disableEditing() {
      return this.$route.query.Id !== '' && this.$route.query.Id !== undefined
    },
    close() {
      this.$router.push('/formula')
    },
    setVarLabelForAllFormula() {
      // set VarLabel
      var VarLabel = this.form.VarLabel
      this.formulaTable.map(function (item) {
        item.VarLabel = VarLabel
        return item
      })
    },
    setFormulaLenght() {
      // update formulaLength
      this.formulaLength = this.formulaTable.length + 1
    },
    setLastVarNameOfFormula() {
      // set latest formula VarName
      var VarName = this.form.VarName
      this.formulaTable[this.formulaTable.length - 1].VarName = VarName

      // setDceGroupDeviceId
      this.formulaTable[
        this.formulaTable.length - 1
      ].DceGroupDeviceId = this.getDceGroupDeviceId()

      // set unit and device group
      this.formulaTable[this.formulaTable.length - 1].Unit = this.form.Unit
      this.formulaTable[
        this.formulaTable.length - 1
      ].GroupDeviceName = this.form.GroupDeviceName
    },
    getDceGroupDeviceId(obj) {
      return `${this.form.DceGroupDeviceId}#${this.form.GroupDeviceName}`
    },

    async fetchDataById() {
      try {
        if (!this.$route.query.Id) {
          return
        }

        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.formula.decryptFormulaToFormulaCreateModel +
            `?idFormula=${this.$route.query.Id}`
        )

        var data = JSON.parse(JSON.stringify(res.data))
        var commonData = data[data.length - 1]
        // this.sensorData = res.data

        this.form.Id = commonData.Id
        this.form.NoUrut = 1
        this.form.VarName = commonData.VarName
        this.form.VarType = commonData.VarType
        this.form.VarLabel = commonData.VarLabel
        this.form.ListSensorDceId = commonData.ListSensorDceId
        this.form.CustomerName = this.form.CustomerName
        this.form.Tags = commonData.Tags
        this.form.Unit = commonData.Unit
        this.form.GroupDeviceName = commonData.GroupDeviceName
        this.form.ProcessForm =
          data.length > 1 ? 'formula' : commonData.ProcessForm

        // append to formula table
        this.formulaTable = data

        // set selected deviceGroupsTree
        this.form.DceGroupDeviceId = commonData.DceGroupDeviceId
        this.$refs.deviceGroupsTree.setCheckedKeys([this.form.DceGroupDeviceId])

        if (this.form.DceGroupDeviceId) {
          this.deviceGroups = this.setDeviceGroupDisability(
            this.deviceGroups,
            this.form.DceGroupDeviceId
          )
        }

        // update formula length
        this.setFormulaLenght()
        if (this.formulaTable.length > 0) {
          this.formulaTable[this.formulaTable.length - 1].VarName +=
            ' - ' + (this.formulaLength - 1)
        }

        this.$emit('fetch-sensor-data', {
          deviceDceIds: [],
          customerSensorIds: commonData.ListSensorDceId
        })

        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async fetchDeviceGroup() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.treeGroupDevice.getCustTreeGroupDeviceLevel +
            `?CustomerDcoId=${this.$route.query.customerId}`
        )
        this.deviceGroups = res.data
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    async fetchFormulaConstanta() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.formula.getAllConstantMaster
        )
        this.formulaConstanta = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async fetchTags() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.tag.listStringTagsAuthorize
        )
        this.tags = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async done() {
      try {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            this.$emit('update-form', this.$event)
            // compile selected Sensor Id
            if (this.form.ProcessForm === 'formula') {
              // select all sensor on formula operation
              this.form.ListSensorDceId = this.sensorData.map(
                (x) => x.DceSensorId
              )
            } else {
              // selected sensors only
              this.form.ListSensorDceId = this.checkedSensors
            }

            // ==== Validate
            // check ListSensorDceId
            if (!this.form.ListSensorDceId.length && !this.$route.query.Id) {
              this.$message.error('At least select one Sensor to continue')
              return
            }

            // check DceGroupDeviceId
            if (!this.form.DceGroupDeviceId.length) {
              this.$message.error(
                'At least select one Device Group to continue'
              )
              return
            }
            // ==== Validate

            // ==== processing data
            this.loading = true
            this.disableButton = true

            var url = '',
              data

            // submit new data
            if (!this.$route.query.Id) {
              if (this.form.ProcessForm === 'formula') {
                // set lastVarNameOfFormula
                this.setLastVarNameOfFormula()

                url = this.$appInfo.api.formula.insertBulkNewFormula
                data = this.formulaTable
              } else {
                // setDceGroupDeviceId
                this.form.DceGroupDeviceId = this.getDceGroupDeviceId()

                this.form.VarType = 'bulksensor'

                url = this.$appInfo.api.formula.insertNewFormula
                data = this.form
              }

              // sending create formula request
              await this.$axios
                .post(url, data)
                .then(() => {
                  this.$message.success('Custom Formula Created')
                })
                .catch((error) => {
                  var response = error.response
                  var message = 'System Error. Please contact the administrator'

                  if (response.status !== 500) {
                    message = response.data.message
                  }

                  this.loading = false
                  this.$message.error(message)
                  this.disableButton = false
                  throw message
                })
            } else {
              if (this.form.ProcessForm === 'formula') {
                // set lastVarNameOfFormula
                this.setLastVarNameOfFormula()

                url = this.$appInfo.api.formula.updatingBulkFormula
                data = this.formulaTable

                // update tags
                data.Tags = this.form.Tags
              } else {
                url = this.$appInfo.api.formula.put
                this.form.VarType = 'bulksensor'
                data = this.form
              }

              // sending update formula request
              await this.$axios
                .put(url, data)
                .then(() => {
                  this.$message.success('Custom Formula Updated')
                })
                .catch((error) => {
                  var response = error.response
                  var message = 'System Error. Please contact the administrator'

                  if (response.status !== 500) {
                    message = response.data.message
                  }

                  this.loading = false
                  this.$message.error(message)
                  this.disableButton = false
                  throw message
                })
            }
            // ==== processing data

            this.$router.push({ name: 'formula-list' })
            // this.sensorData.push(this.form)
            this.loading = false
          } else {
            this.$message.warning('Please fill in the required data')
            this.loading = false
            return false
          }
        })
      } catch (e) {
        this.loading = false
        this.$message.error(e)
        console.log(e)
      }
    },
    async getCustomer() {
      try {
        this.loading = true
        const res = await this.$axios.get(this.$appInfo.api.customer.getAll)
        this.customer = res.data

        var selectedCompany = this.customer.find(
          (x) => x.DcoId === this.$route.query.customerId
        )
        this.form.CustomerName = selectedCompany ? selectedCompany.DcoId : ''

        this.formulaData.CustomerName = this.form.CustomerName

        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async validateName(name) {
      try {
        if (this.disableEditing()) {
          return true
        }

        const res = await this.$axios.get(
          this.$appInfo.api.formula.isAvailableVarNameFormula +
            '?varName=' +
            name
        )
        return res.data
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {
    filterdeviceGroups(val) {
      this.$refs.deviceGroupsTree.filter(val)
    }
  }
}
</script>
